import { init } from '@rematch/core';
import helpers from './shared';
import users from './Users';
import displays from './Displays';
import advertisers from './Advertisers';
import distributors from './Distributors';
import settings from './Settings';
import signupUsers from './SignupUsers';
import signJetSync from './SignJetSync';
const store = init({
  models: {
    ...helpers,
    ...users,
    ...displays,
    ...advertisers,
    ...distributors,
    ...settings,
    ...signupUsers,
    ...signJetSync,
  },
});
export default store;
